var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"purple","to":{ name: _vm.RouteNames.CreateTournamentRoute }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v(" Create ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }